

import Statistic from "./Statistic";
import request from "../../../request";
import { capitalize } from "@mui/material";

export default function RevenueByProduct() {

   return <Statistic
      title="Revenue by Product"
      variant="bar"
      allowFullSizeChart
      fetchData={async (from, to) => {

         const res = await request.get('/api/general/reports/revenue-by-product', { params: { from, to } });
         const { products } = res.data;

         const count = { label: "Count", cards: [] };
         const revenue = { label: "Revenue", cards: [] };

         for (const product of products) {
            const { name, collected_revenue, expected_revenue, count: _count } = product;
            revenue.cards.push({
               title: capitalize(name),
               number: {
                  Expected: expected_revenue,
                  Collected: collected_revenue
               }
            });

            count.cards.push({
               title: capitalize(name),
               number: _count
            });
         }

         const tabs = [ count, revenue ];

         return tabs;
      }}
   />
}